/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".skyvector-chart__chart[_ngcontent-%COMP%]{height:100%}"];
export { styles as styles };
